import React, {useState} from "react";

const Footer = () => {
  return (
    <div className="bg-main-black text-white/60 text-center h-[76px] text-res-sm leading-[24px] flex justify-center items-center font-bold">
      <p>
        {" "}
        Copyright <span className="font-normal">&copy; </span> 2023. All Rights
        Reserved
      </p>
    </div>
  );
};

export default Footer;
